"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Utils = require("../Utils");
var _SuperSpectrumInput = _interopRequireDefault(require("./SuperSpectrumInput"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var ColorInputs = function ColorInputs(_ref) {
  var hexCode = _ref.hexCode,
    rgba = _ref.rgba,
    handleHexCodeInput = _ref.handleHexCodeInput,
    handleRGBAInput = _ref.handleRGBAInput,
    noColor = _ref.noColor,
    type = _ref.type;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(_Utils.PREFIX_CLASSNAME, "-inputs")
  }, type === "hex" && /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(_Utils.PREFIX_CLASSNAME, "-hex-input")
  }, /*#__PURE__*/_react.default.createElement(_SuperSpectrumInput.default, {
    noColor: noColor,
    name: "hex",
    id: "hex",
    value: hexCode,
    handleChange: handleHexCodeInput,
    handleKeyDown: _Utils.preventExtraHash,
    label: "hex"
  })), type === "rgb" && /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(_Utils.PREFIX_CLASSNAME, "-rgb-input")
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(_Utils.PREFIX_CLASSNAME, "-r-input")
  }, /*#__PURE__*/_react.default.createElement(_SuperSpectrumInput.default, {
    noColor: noColor,
    name: "r",
    id: "r",
    value: rgba.r,
    handleChange: handleRGBAInput,
    label: "R",
    className: "".concat(_Utils.PREFIX_CLASSNAME, "-red")
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(_Utils.PREFIX_CLASSNAME, "-g-input")
  }, /*#__PURE__*/_react.default.createElement(_SuperSpectrumInput.default, {
    noColor: noColor,
    name: "g",
    id: "g",
    value: rgba.g,
    handleChange: handleRGBAInput,
    className: "".concat(_Utils.PREFIX_CLASSNAME, "-green")
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(_Utils.PREFIX_CLASSNAME, "-b-input")
  }, /*#__PURE__*/_react.default.createElement(_SuperSpectrumInput.default, {
    noColor: noColor,
    name: "b",
    id: "b",
    value: rgba.b,
    handleChange: handleRGBAInput,
    className: "".concat(_Utils.PREFIX_CLASSNAME, "-blue")
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(_Utils.PREFIX_CLASSNAME, "-alpha-input")
  }, /*#__PURE__*/_react.default.createElement(_SuperSpectrumInput.default, {
    noColor: noColor,
    name: "alpha",
    id: "alpha",
    value: "".concat(rgba.alpha),
    handleChange: handleRGBAInput,
    className: "".concat(_Utils.PREFIX_CLASSNAME, "-alpha"),
    label: "A"
  }), /*#__PURE__*/_react.default.createElement("span", {
    className: "".concat(_Utils.PREFIX_CLASSNAME, "-percent-symbol")
  }, "%")));
};
var _default = ColorInputs;
exports.default = _default;